export default __webpack_public_path__ + "static/media/brand-logo.5e8e9968.svg";